import { BannerSection } from "@/components/sections/section-banner";
import { CertificationSection } from "@/components/sections/section-certification";
import { TestimonialSection } from "@/components/sections/section-testimonial";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function TestimonialPage() {
  return (
    <div className="bg-n-bg-1">
      {/* Hero Section */}
      <section className="py-20 px-4 md:px-8 lg:px-16 bg-n-green">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              O que nossos clientes dizem
            </h1>
            <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
              Mais de 100.000 clientes já confiaram na Nacional GO para
              transportar seus veículos. Confira alguns depoimentos.
            </p>
            <div className="flex items-center justify-center gap-2 text-n-yellow">
              {[...Array(5)].map((_, i) => (
                <Star key={i} fill="currentColor" />
              ))}
            </div>
            <p className="text-white mt-4 font-semibold">
              4.8/5 - Mais de 10.000 avaliações
            </p>
          </motion.div>
        </div>
      </section>

      {/* Números Section */}
      <section className="py-16 px-4 md:px-8 lg:px-16 bg-n-bg-1">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center p-6 rounded-lg bg-gray-50"
            >
              <h3 className="text-4xl font-bold text-n-yellow mb-2">98%</h3>
              <p className="text-n-green">
                dos nossos clientes recomendam nossos serviços
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="text-center p-6 rounded-lg bg-gray-50"
            >
              <h3 className="text-4xl font-bold text-n-yellow mb-2">+100mil</h3>
              <p className="text-n-green">
                veículos transportados com segurança
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-center p-6 rounded-lg bg-gray-50"
            >
              <h3 className="text-4xl font-bold text-n-yellow mb-2">4.8/5</h3>
              <p className="text-n-green">
                nota média de satisfação dos clientes
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <TestimonialSection />

      <BannerSection title="Faça agora uma cotação e agende o transporte do seu veículo !" />

      <CertificationSection />
    </div>
  );
}
